import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {NumericTextBoxModule} from "@syncfusion/ej2-angular-inputs";
import {DatePickerModule} from "@syncfusion/ej2-angular-calendars";

@Component({
    selector: 'app-form-numeric',
    imports: [
        NumericTextBoxModule,
        ReactiveFormsModule,
        DatePickerModule
    ],
    templateUrl: './form-numeric.component.html',
    styleUrl: './form-numeric.component.scss'
})
export class FormNumericComponent implements OnInit {
  @Input() public fCN: string = '';
  @Input() public disabled: boolean = false;
  @Input() public cssClass: string = '';
  @Input() public step: number = 1;
  @Input() public min: number | null = 0;
  @Input() public max?: number | null = null;
  @Input() public fG: FormGroup = new FormGroup({});

  public ngOnInit(): void {
    if (this.disabled) {
      this.fG.controls[this.fCN].disable();
    }
  }
}
